import { FilterKey } from '@studyportals/search-filters';
import { BaseFilterKeyValueRule } from '../../common/rules/BaseFilterKeyValueRule';
export class OnlineAttendanceRule extends BaseFilterKeyValueRule {
    constructor() {
        const filterKeyValues = new Map([[FilterKey.DELIVERY_METHOD, ['online']]]);
        super(filterKeyValues);
    }
    getName() {
        return 'OnlineAttendanceRule';
    }
}
